import {useQuery} from '@tanstack/react-query';

import {PowerCapacityId} from '../../query/graphql';
import {POWER_CAPACITIES} from '../resources/capacities';
import {getCrop} from '../resources/crops';
import {getGenericYieldWhenUsedForSimpleCalculators} from './calculations';
import {SimpleCalculatorCrop} from './types';

type Input = {
  capacityId?: PowerCapacityId;
  cropId?: SimpleCalculatorCrop;
};

type Output = {
  fuelRequirement?: number;
  inUseMC?: number;
  genericYield?: number;
  areaRequired?: number;
  landTake?: number;
};

export function calculateLargeScale({capacityId, cropId}: Input): Output {
  const fuelRequirement = capacityId ? POWER_CAPACITIES[capacityId].fuelRequirement : undefined;
  const inUseMC = cropId ? getCrop(cropId).inUseMC : undefined;
  const genericYield = cropId ? getGenericYieldWhenUsedForSimpleCalculators(cropId) : undefined;
  const areaRequired =
    fuelRequirement !== undefined && genericYield !== undefined ? fuelRequirement / genericYield : undefined;
  const landTake = areaRequired !== undefined ? (areaRequired / 785000) * 100 : undefined;

  return {
    fuelRequirement,
    inUseMC,
    genericYield,
    areaRequired,
    landTake,
  };
}

export function useLargeScaleCalculator(input: Input) {
  return useQuery({
    queryKey: [input.capacityId, input.cropId],
    queryFn: () => calculateLargeScale(input),
  });
}
